define('models/portal',["require", "exports", "models/account"], function (require, exports, Account) {
    "use strict";
    var Context = (function () {
        function Context() {
        }
        Object.defineProperty(Context, "shell", {
            get: function () {
                return Context._shell;
            },
            set: function (instance) {
                Context._shell = instance;
            },
            enumerable: true,
            configurable: true
        });
        return Context;
    }());
    exports.Context = Context;
    var ContentDialog = (function () {
        function ContentDialog() {
        }
        return ContentDialog;
    }());
    exports.ContentDialog = ContentDialog;
    // #region breadcrumb
    var BreadCrumbItem = (function () {
        // #region creation
        function BreadCrumbItem() {
            this.items = [];
            ko.track(this, ["name", "icon", "items"]);
        }
        BreadCrumbItem.from = function (name, icon, thumbnail, source, clickAction) {
            if (icon === void 0) { icon = null; }
            if (thumbnail === void 0) { thumbnail = null; }
            if (source === void 0) { source = null; }
            if (clickAction === void 0) { clickAction = null; }
            var item = new BreadCrumbItem();
            item.name = name;
            item.icon = icon;
            item.thumbnail = thumbnail;
            item.clickAction = clickAction;
            item.source = source;
            return item;
        };
        // #endregion
        BreadCrumbItem.prototype.execute = function () {
            if (this.clickAction == null)
                return;
            this.clickAction(this);
        };
        return BreadCrumbItem;
    }());
    exports.BreadCrumbItem = BreadCrumbItem;
    var ModuleBreadCrumbItemHolder = (function () {
        function ModuleBreadCrumbItemHolder() {
            this.rootChilds = [];
            this.items = [];
            ko.track(this, ["rootChilds", "items"]);
        }
        return ModuleBreadCrumbItemHolder;
    }());
    exports.ModuleBreadCrumbItemHolder = ModuleBreadCrumbItemHolder;
    // #endregion
    // #region modules
    var Application = (function () {
        function Application() {
        }
        Application.from = function (data) {
            var result = new Application();
            result.id = data.id;
            result.name = data.name;
            result.settingsXml = data.settingsXml;
            result.target = data.target;
            return result;
        };
        return Application;
    }());
    exports.Application = Application;
    var ApplicationContext = (function () {
        function ApplicationContext(path, settings, queryString, parameters) {
            this.path = path;
            this.settings = settings;
            this.queryString = queryString;
            this.callingParameters = parameters;
        }
        return ApplicationContext;
    }());
    exports.ApplicationContext = ApplicationContext;
    var ParameterList = (function () {
        function ParameterList() {
            this._parameters = new Array();
        }
        ParameterList.prototype.add = function (key, value) {
            this._parameters[key] = value;
        };
        ParameterList.prototype.get = function (key) {
            return this._parameters[key];
        };
        return ParameterList;
    }());
    exports.ParameterList = ParameterList;
    var ModuleRouteConfiguration = (function () {
        function ModuleRouteConfiguration() {
        }
        return ModuleRouteConfiguration;
    }());
    exports.ModuleRouteConfiguration = ModuleRouteConfiguration;
    var ChildRouteConfiguration = (function () {
        function ChildRouteConfiguration() {
        }
        return ChildRouteConfiguration;
    }());
    exports.ChildRouteConfiguration = ChildRouteConfiguration;
    var ModuleInfo = (function () {
        function ModuleInfo() {
        }
        ModuleInfo.from = function (data) {
            var result = new ModuleInfo();
            result.id = data.id;
            result.memberType = data.memberType;
            result.name = data.name;
            result.originalName = data.originalName;
            result.imagePath = data.imagePath;
            result.category = data.category;
            result.description = data.description;
            result.settingsXml = data.settingsXml;
            result.visibilityRulesXml = data.visibilityRulesXml;
            result.isDisabled = data.isDisabled;
            result.isMainApplication = data.isMainApplication;
            result.isDeleted = data.isDeleted;
            result.isCustomApplication = data.isCustomApplication;
            result.applicationFlags = data.applicationFlags;
            result.guiltyFrom = data.guiltyFrom;
            result.guiltyTo = data.guiltyTo;
            result.createdOn = data.createdOn;
            result.updatedOn = data.updatedOn;
            result.templateId = data.templateId;
            result.tileId = data.rowKey;
            result.uniqueItemId = data.templateId;
            result.template = Application.from(data);
            return result;
        };
        Object.defineProperty(ModuleInfo.prototype, "configuration", {
            get: function () {
                if (this._routeConfiguration == null) {
                    this.readRouteConfiguration();
                }
                return this._routeConfiguration;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ModuleInfo.prototype, "isHtmlApp", {
            get: function () {
                return this.area != null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ModuleInfo.prototype, "isExternalApp", {
            get: function () {
                return this.link != null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ModuleInfo.prototype, "embedApp", {
            get: function () {
                if (this.isExternalApp) {
                    var xml = jQuery.parseXML(this.template.settingsXml);
                    var elements = xml.getElementsByTagName("html");
                    if (elements.length == 0)
                        return false;
                    var html = elements.item(0);
                    if (html.hasChildNodes()) {
                        for (var i = 0; i < html.childNodes.length; i++) {
                            var node = html.childNodes.item(i);
                            if (node.nodeName === "embed") {
                                return node.textContent === "true" ? true : false;
                            }
                        }
                    }
                }
                return true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ModuleInfo.prototype, "area", {
            get: function () {
                var xml = jQuery.parseXML(this.template.settingsXml);
                var elements = xml.getElementsByTagName("html");
                if (elements.length == 0)
                    return null;
                var html = elements.item(0);
                if (html.hasChildNodes()) {
                    for (var i = 0; i < html.childNodes.length; i++) {
                        var node = html.childNodes.item(i);
                        if (node.nodeName == "area")
                            return node.textContent;
                    }
                }
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ModuleInfo.prototype, "link", {
            get: function () {
                var xml = jQuery.parseXML(this.template.settingsXml);
                var url = this.template.target;
                // prüfen ob es ein externer Aufruf ist
                var type = this.getXmlTextContent(xml, "typename");
                if (type != null)
                    return null;
                return this.appendUrl(url);
            },
            enumerable: true,
            configurable: true
        });
        // #region url manipulation
        ModuleInfo.prototype.appendUrl = function (url) {
            var xml = jQuery.parseXML(this.template.settingsXml);
            // prüfen ob das token anzuhängen ist
            var appendToken = this.getXmlTextContent(xml, "appendtokenid");
            if (appendToken != null && appendToken == "true") {
                url = this.appendToken(url);
            }
            // prüfen ob die orgid anzuhängen ist
            var appendOrgId = this.getXmlTextContent(xml, "appendorgid");
            if (appendOrgId != null && appendOrgId == "true") {
                url = this.appendOrganizationId(url);
            }
            // prüfen ob die orgid anzuhängen ist
            var appendsubdomain = this.getXmlTextContent(xml, "appendsubdomain");
            if (appendsubdomain != null && appendsubdomain == "true") {
                url = this.appendsubdomain(url);
            }
            // Adding IdToken & AccessToken to url
            var appendTokens = this.getXmlTextContent(xml, "appendTokens");
            if (appendTokens != null && appendTokens == "true") {
                url = this.appendBothToken(url);
            }
            return url;
        };
        ModuleInfo.prototype.appendToken = function (url) {
            var tokenId = jQuery.base64.encode(Account.Session.getSessionId(), true);
            var appendee = url.indexOf("?") > -1 ? "&" : "?";
            return url + appendee + "tokenId=" + tokenId;
        };
        ModuleInfo.prototype.appendOrganizationId = function (url) {
            var orgId = jQuery.base64.encode(Account.Principal.current.organizationId, true);
            var appendee = url.indexOf("?") > -1 ? "&" : "?";
            return url + appendee + "orgId=" + orgId;
        };
        ModuleInfo.prototype.appendsubdomain = function (url) {
            var subdomain = window.location.hostname.substring(0, window.location.hostname.indexOf("."));
            var updatedUrl = url.replace("practicesubdomain", subdomain);
            return updatedUrl;
        };
        ModuleInfo.prototype.appendBothToken = function (url) {
            var appendee = url.substr(-1) == "/" ? "" : "/";
            var idToken = localStorage.getItem('idToken');
            var accessToken = sessionStorage.getItem("accessToken");
            return url + appendee + "#id_token=" + idToken + "&access_token=" + accessToken;
        };
        // #endregion
        // #region tools
        ModuleInfo.prototype.readRouteConfiguration = function () {
            this._routeConfiguration = this.getHtmlConfiguration();
            this._routeConfiguration.title = this.name;
            //this._routeConfiguration.isNavigationVisible = this.isMainApplication;
            this._routeConfiguration.isNavigationVisible = false;
            // set route data
            //var name: string = this.originalName.replace(/ /g, "").replace(/\//g, "").toLowerCase();
            var name = this.name.replace(/ /g, "").replace(/\//g, "").toLowerCase();
            if (this._routeConfiguration.area == null) {
                this._routeConfiguration.route = "silverlight/" + name;
                this._routeConfiguration.moduleId = "appcenter/viewmodels/silverlight";
            }
            else if (this._routeConfiguration.isNavigationVisible) {
                this._routeConfiguration.route = name;
                this._routeConfiguration.moduleId = this._routeConfiguration.area + "/viewmodels/" + this._routeConfiguration.viewModel;
            }
            else {
                this._routeConfiguration.route = "meineapps/" + name;
                this._routeConfiguration.moduleId = this._routeConfiguration.area + "/viewmodels/" + this._routeConfiguration.viewModel;
            }
        };
        ModuleInfo.prototype.getHtmlConfiguration = function () {
            var xml = jQuery.parseXML(this.template.settingsXml);
            var configuration = new ModuleRouteConfiguration();
            var elements = xml.getElementsByTagName("html");
            if (elements.length === 0)
                return configuration;
            var html = elements.item(0);
            if (html.hasChildNodes()) {
                for (var i = 0; i < html.childNodes.length; i++) {
                    var node = html.childNodes.item(i);
                    if (node.nodeName === "area") {
                        configuration.area = node.textContent;
                        if (configuration.viewModel == null)
                            configuration.viewModel = "index";
                    }
                    if (node.nodeName === "viewModel")
                        configuration.viewModel = node.textContent;
                    if (node.nodeName === "deepLinks") {
                        configuration.deepLinks = new Array();
                        for (var n = 0; n < node.childNodes.length; n++) {
                            var routeNode = node.childNodes.item(n);
                            var route = new ChildRouteConfiguration();
                            for (var x = 0; x < routeNode.childNodes.length; x++) {
                                var temp = routeNode.childNodes.item(x);
                                if (temp.nodeName === "path") {
                                    route.path = temp.textContent;
                                }
                                if (temp.nodeName === "module") {
                                    route.module = temp.textContent;
                                }
                            }
                            configuration.deepLinks.push(route);
                        }
                    }
                }
            }
            return configuration;
        };
        ModuleInfo.prototype.getXmlTextContent = function (xml, symbol) {
            var elements = xml.getElementsByTagName(symbol);
            if (elements.length !== 0) {
                var type = elements.item(0);
                if (type.textContent !== "")
                    return type.textContent;
            }
            return null;
        };
        return ModuleInfo;
    }());
    exports.ModuleInfo = ModuleInfo;
    var PortalUri = (function () {
        function PortalUri() {
        }
        PortalUri.mapToUniqueItemId = function (uri) {
            var source = decodeURI(uri).toLowerCase().replace("+", " ");
            if (source.indexOf("portal://auswertung online") >= 0) {
                return "080F72D5-8A6A-4C54-B10D-5648B6F093E2";
            }
            else if (source.indexOf("portal://benutzerdaten verwalten") >= 0) {
                return "BB0BD3A1-8F77-4775-95E8-4A9A36855EEE";
            }
            else if (source.indexOf("portal://postfach") >= 0) {
                return "1E08B4CF-3BAA-49E9-B266-AD8A8AA984DC";
            }
            else if (source.indexOf("portal://portal individualisierung") >= 0) {
                return "E1439353-11EA-4820-85DE-7B2FFFD93753";
            }
            return null;
        };
        return PortalUri;
    }());
    exports.PortalUri = PortalUri;
});
// #endregion 
;
